<app-header></app-header>
<app-back-button class="block mb-lg"></app-back-button>
<app-page-title>{{ 'docs.title' | translate }}</app-page-title>
<app-common-spacer></app-common-spacer>
<div class="documents-lists">
  @for (document of additionalDocumentsList$ | async; track document.id) {
    <app-document-card class="item-doc"
                       [previewMode]="(previewMode$ | async) ?? false"
                       [document]="document"
                       (downloadDocument)="downloadDocument($event)">
    </app-document-card>
  }
</div>
<app-common-spacer></app-common-spacer>
<app-content-sections></app-content-sections>
<div class="mt-3xl"></div>
<app-footer-info></app-footer-info>
